import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthPromptService } from '../../auth/auth-prompt.service';
import { ERROR_MESSAGE_SETTER } from '../../app.tokens';
import type { IErrorMessageSetter } from '../../app.tokens';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent {
  readonly defaultHeading = 'Error';
  readonly defaultMessage = 'An unexpected error has occurred. Please try again.';

  constructor(
    @Inject(ERROR_MESSAGE_SETTER) private readonly errorMessageSetter: IErrorMessageSetter,
    private readonly authPromptService: AuthPromptService
  ) {}

  get heading(): string {
    return (this.errorMessageSetter.errorMessageHeading?.value || '').trim() || this.defaultHeading;
  }

  get message(): string {
    return (this.errorMessageSetter.errorMessage?.value || '').trim() || this.defaultMessage;
  }

  onLoginClick(): void {
    // User explicitly requested login while on /error.
    this.authPromptService.promptLogin(true);
  }
}

